// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { Injectable } from '@angular/core';
import { TableDataRow } from '@lfx/key-projects/key-projects.model';
import { KeyProjectsTableEntity } from '@lfx/key-projects/entities/key-projects-table.entity';

/**
 * Service responsible for sorting table data
 * Follows Clean Architecture: Service delegates to entity for business logic
 */
@Injectable({ providedIn: 'root' })
export class TableSortingService {
  /**
   * Sort table data based on column property and direction
   *
   * @param data - Array of table data rows to sort
   * @param columnProp - Column property to sort by
   * @param direction - Sort direction ('asc' or 'desc')
   * @returns Sorted array of table data rows
   */
  sortTableData(
    data: TableDataRow[],
    columnProp: string,
    direction: 'asc' | 'desc'
  ): TableDataRow[] {
    if (!data || data.length === 0) {
      return data;
    }

    // Convert direction to numeric multiplier
    const directionMultiplier = direction === 'asc' ? 1 : -1;

    // Get the appropriate sort comparator from entity
    const comparator = KeyProjectsTableEntity.getSortComparator(columnProp);

    if (!comparator) {
      return data;
    }

    // Sort data using the comparator
    return [...data].sort((a, b) => comparator(a, b, directionMultiplier));
  }
}

